import { render, staticRenderFns } from "./TaxHistory.vue?vue&type=template&id=1b73dc29&scoped=true&"
import script from "./TaxHistory.vue?vue&type=script&lang=js&"
export * from "./TaxHistory.vue?vue&type=script&lang=js&"
import style0 from "./TaxHistory.vue?vue&type=style&index=0&id=1b73dc29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b73dc29",
  null
  
)

export default component.exports